import { NgModule } from "@angular/core";
import { DefaultUrlSerializer, RouterModule, Routes, UrlSerializer } from "@angular/router";
import { MainPageLibRoutingModule } from "@dtm-frontend/main-page-lib";
import { NOT_FOUND_ROUTE } from "@dtm-frontend/shared/utils";

const routes: Routes = [{ path: "**", redirectTo: `/${NOT_FOUND_ROUTE}` }];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" }), MainPageLibRoutingModule],
    exports: [RouterModule],
    providers: [
        {
            provide: UrlSerializer,
            useClass: class extends DefaultUrlSerializer {
                public parse(url: string) {
                    const urlObj = new URL(url, "https://host"); // NOTE:  Base URL is required for relative URLs
                    const lowerCasePath = urlObj.pathname.toLowerCase();
                    const newUrl = `${lowerCasePath}${urlObj.search}${urlObj.hash}`;

                    return super.parse(newUrl);
                }
            },
        },
    ],
})
export class AppRoutingModule {}
